module.exports = __webpack_public_path__ + "img/incense-stone.6f4f2eb0.jpeg";